export default "__VITE_ASSET__Bngl6NfA__"